import { useAppThemeContext } from "@/theme/AppThemeContextProvider"

import type { BreakpointToken } from "./theme/breakpoints"

export type BreakpointInputValue<V> = {
  [key in BreakpointToken | "base"]?: V
}
export interface ResponsiveComponentProps {
  breakpoint?: BreakpointToken
}
export function useBreakpointValue() {
  const { screenSize } = useAppThemeContext()

  return function getValue<V>(props: BreakpointInputValue<V>) {
    if (screenSize === "xl") {
      return props.xl ?? props.lg ?? props.md ?? props.sm ?? props.base
    }
    if (screenSize === "lg") {
      return props.lg ?? props.md ?? props.sm ?? props.base
    }
    if (screenSize === "md") {
      return props.md ?? props.sm ?? props.base
    }

    if (screenSize === "sm") {
      return props.sm ?? props.base
    }

    return props.base
  }
}
